<template>
  <div class="field">
    <div class="notifications-container">
      <div v-if="somethingToNotify" class="uk-alert" uk-alert>
        <p v-if="acquiredCard">🎉 {{ $t("notifications.cardAcquired", {card: acquiredCard, player: currentPlayer.name}) }}</p>
        <p v-if="winner">{{ winner.emoji.symbol }} {{ $t("notifications.won", {player: winner.name}) }} </p>
        <p v-if="tie">{{ $t("notifications.tie") }} </p>
        <p v-if="finishSinglePlayer">{{ $t("notifications.finished", { score: winnerScore}) }}</p>
      </div>
    </div>
    <div class="cards-container">
      <div class="card-row" v-for="row in cardRows">
        <bird-card v-for="card in row" :card="card" :inTheField="true" @turnedUp="stopAllSounds"></bird-card>
      </div>
     </div>
      <div class="cta">
        <template v-if="gameInProgress">
          <button @click="onTwoCardsUp" :class="['uk-button', {'uk-button-primary': !showingMatch, 'uk-button-secondary': showingMatch}]" v-if="facingUpCount === 2">{{ $t(callToAction) }}</button>
          <button v-if="!singlePlayer && !gameInProgress" @click="nextRound" class="uk-button uk-button-danger">{{ $t("buttons.skipRound") }}</button>
        </template>
        <template v-else>
          <p>
            <button class="uk-button uk-button-primary" @click="playAgainClicked">{{ $t("buttons.playAgain") }}</button>
            <router-link to="/" tag="button" class="uk-button uk-button-secondary">{{ $t("buttons.backToMenu") }}</router-link>
          </p>
        </template>
      </div>
  </div>
</template>
<script>
  import { mapGetters } from "vuex"
  import Card from "./Card.vue"

  export default {
    components: {
      birdCard: Card
    },
    computed: {
      winner() {
        if (!this.singlePlayer && !this.gameInProgress) {
          return this.$store.getters.winner;
        }
      },
      tie() {
        if (!this.singlePlayer && !this.gameInProgress) {
          return !this.winner;
        }
      },
      finishSinglePlayer() {
        return this.singlePlayer && !this.gameInProgress
      },
      cardRows() {
        let chunks = [];
        let i = 0;
        let n = this.cards.length;
        while (i < n) { chunks.push(this.cards.slice(i, i+= this.columnsCount))}
        return chunks;
      },
      callToAction() {
        return this.showingMatch ? "buttons.acquire" : "buttons.hide"
      },
      columnsCount() {
        let squares = [4,9,16,25,36,49,64]
        return Math.sqrt(squares.find(s => s >= this.cards.length));
      },
      lastCardText() {
        if (this.tempLastCard) {
          return this.tempLastCard.text;
        }
      },
      acquiredCard() {
        if(this.lastCardText && this.showingMatch) {
          return this.lastCardText;
        }
      },
      somethingToNotify() {
        if (this.acquiredCard || !this.gameInProgress) {
          return true;
        }
      },
      ...mapGetters(["currentPlayer", "tempLastCard", "showingMatch", "facingUpCount", "cards", "gameInProgress", "singlePlayer", "winnerScore"])
    },
    methods: {
      onTwoCardsUp() {
        if (this.showingMatch) {
          this.$store.dispatch("acquire");
        } else {
          this.$store.dispatch("hide");
          this.$store.dispatch("nextRound");
        }
        this.stopAllSounds();
      },
      nextRound() {
        this.cards.forEach(card => card.sound.stop());
        this.$store.dispatch("nextRound")
      },
      playAgainClicked() {
        this.$store.dispatch("initCards");
        this.$store.dispatch("clearPlayerTries")
      },
      stopAllSounds() {
        this.cards.forEach(card => card.sound.stop());
      }
    },
    created() {
      this.$store.dispatch("initCards");
    }
  }
</script>
<style scoped>
  .field {
    width: 75%;
    display: flex;
    flex-direction: column;
  }
  .cards-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .notifications-container {
    height: 60px;
  }
  .card-row {
    display: flex;
    justify-content: center;
  }
  .cta {
    margin-top: 3em;
  }

</style>



// WEBPACK FOOTER //
// src/components/PlayingField.vue